export default "__VITE_ASSET__D_5N_iQL__"